module.exports = "<div class=Wrapper><div :skin=skins.messages class=\"Message Message--info\"><i style=\"margin-right: 15px\" class=\"fa fa-info\"></i><span class=Message__body>{{{ fdata.value }}}</span></div></div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/forms/_sub/rawHtml.vue
// module id = 421
// module chunks = 0